import templateUrl from './select-dropdown.html';

export const selectDropdownComponent = {
        bindings: {
                list: '<',
                labelText: '@',
                selectedId: '<',
                defaultOption: '@',
                isOptionDisabled: '<',
                onChange: '&'
        },

        templateUrl,

        controller: class SelectDropdownComponent {
                constructor($parse) {
                        'ngInject';

                        this.$parse = $parse;
                }

                $onInit() {
                        this.selectedId = this.selectedId || null;
                        this.isDisabled = !this.isOptionDisabled ? false : true;
                        this._displayRange = this.$parse(this.displayRange || 'false')(false);
                }
        }
};


// WEBPACK FOOTER //
// ./src/app/common/components/select-dropdown/select-dropdown.component.js